<div class="suporte-whatsapp">
  <div class="suporte-header">
    <div>
      <p class="suporte-label">{{clientePkt ? 'Suporte MeuCardapio' : 'Modo suporte'}}</p>
      <h4>{{nomeGrupo || 'Grupo do WhatsApp'}}</h4>
      <span class="chat-id" *ngIf="grupoId">{{grupoId}}</span>
    </div>

    <div class="assinatura-whatsapp" *ngIf="usuario && !clientePkt">
      <input id="assinarMensagensSuporteGrupo"
             name="assinarMensagensSuporteGrupo"
             type="checkbox"
             kendoCheckBox
             [(ngModel)]="usuario.assinarMensagens"
             [disabled]="salvandoAssinaturaWhatsapp"
             (ngModelChange)="salveAssinaturaWhatsapp()"/>
      <label class="k-checkbox-label" for="assinarMensagensSuporteGrupo">
        Assinar mensagens
      </label>
      <span *ngIf="salvandoAssinaturaWhatsapp" class="fa fa-spinner fa-spin"></span>
    </div>
  </div>

  <div class="alert alert-warning" *ngIf="!podeUsarModoSuporte() && !erro && !clientePkt">
    Modo suporte disponível apenas para admins da Fibo.
  </div>

  <div class="alert alert-danger" *ngIf="erro">
    {{erro}}
  </div>

  <div class="k-i-loading carregando" *ngIf="carregando"></div>

  <section class="cliente-pkt-suporte" *ngIf="!carregando && clientePkt">
    <div class="cliente-pkt-topo">
      <div>
        <p class="secao-label">Grupo de suporte</p>
        <h5>
          {{empresa?.nome}}
        </h5>
        <span>{{nomeGrupo}}</span>
      </div>
    </div>

    <div class="cliente-pkt-informacoes">
      <a *ngIf="obtenhaLinkAdminEmpresaAtual()"
         class="cliente-pkt-info-link"
         [href]="obtenhaLinkAdminEmpresaAtual()"
         target="_blank"
         rel="noopener">
        <i class="fa fa-cog"></i>
        Admin
      </a>

      <a *ngIf="obtenhaLinkCardapioDigital()"
         class="cliente-pkt-info-link"
         [href]="obtenhaLinkCardapioDigital()"
         target="_blank"
         rel="noopener">
        <i class="fa fa-external-link-alt"></i>
        Cardápio digital
      </a>

      <div class="cliente-pkt-horario">
        <p class="secao-label">Horário de funcionamento do suporte</p>
        <span>Segunda a sexta das 9h às 23h</span>
        <span>Sábado das 10h às 22h</span>
        <span>Domingo das 16h às 21h</span>
        <small>Exceto feriados</small>
      </div>
    </div>

    <div class="alert alert-success" *ngIf="ticketClienteCriado">
      Ticket #{{ticketClienteCriado.id}} aberto. A mensagem foi enviada para o grupo.
    </div>

    <div class="alert alert-danger" *ngIf="erroClientePkt">
      {{erroClientePkt}}
    </div>

    <div class="estado-vazio" *ngIf="carregandoClientePkt">
      Verificando vínculo do grupo...
    </div>

    <div class="estado-vazio" *ngIf="!carregandoClientePkt && contextoClientePkt && !contextoClientePkt.habilitado">
      Este grupo PKT não está vinculado a esta empresa.
    </div>

    <div class="cliente-pkt-acoes" *ngIf="!carregandoClientePkt && contextoClientePkt?.habilitado">
      <button type="button"
              class="btn btn-primary btn-sm"
              (click)="abraSolicitacaoSuporte()">
        <i class="fa fa-life-ring"></i>
        Solicitar suporte
      </button>
    </div>

    <div class="solicitacao-suporte-backdrop" *ngIf="exibindoSolicitacaoSuporte">
      <div class="solicitacao-suporte-modal">
        <div class="solicitacao-suporte-topo">
          <div>
            <p class="secao-label">Solicitação de suporte</p>
            <h6>Descreva sua solicitação</h6>
          </div>
          <button type="button"
                  class="btn btn-link btn-sm"
                  (click)="canceleSolicitacaoSuporte()"
                  [disabled]="enviandoSolicitacaoSuporte">
            <i class="fa fa-times"></i>
          </button>
        </div>

        <div class="alert alert-danger" *ngIf="erroSolicitacaoSuporte">
          {{erroSolicitacaoSuporte}}
        </div>

        <textarea class="form-control"
                  rows="5"
                  [(ngModel)]="descricaoSolicitacaoSuporte"
                  [disabled]="enviandoSolicitacaoSuporte"
                  placeholder="Descreva o que está acontecendo"></textarea>

        <div class="solicitacao-suporte-acoes">
          <button type="button"
                  class="btn btn-outline-secondary btn-sm"
                  (click)="canceleSolicitacaoSuporte()"
                  [disabled]="enviandoSolicitacaoSuporte">
            Cancelar
          </button>
          <button type="button"
                  class="btn btn-primary btn-sm"
                  (click)="envieSolicitacaoSuporte()"
                  [disabled]="enviandoSolicitacaoSuporte">
            <i class="fa" [ngClass]="enviandoSolicitacaoSuporte ? 'fa-spinner fa-spin' : 'fa-paper-plane'"></i>
            Enviar
          </button>
        </div>
      </div>
    </div>
  </section>

  <ng-container *ngIf="!carregando && contexto && !clientePkt">
    <section class="meus-tickets-suporte" *ngIf="!contexto.elegivel">
      <div class="meus-tickets-topo">
        <div>
          <p class="secao-label">Fila do operador</p>
          <h5>Meus tickets abertos</h5>
          <span>{{meusTicketsTotal}} ticket(s) sob sua responsabilidade</span>
        </div>

        <button type="button"
                class="btn btn-outline-primary btn-sm"
                (click)="carregueFilasOperador()"
                [disabled]="carregandoMeusTickets || carregandoTicketsDestaque">
          <i class="fa" [ngClass]="(carregandoMeusTickets || carregandoTicketsDestaque) ? 'fa-spinner fa-spin' : 'fa-sync'"></i>
          Atualizar
        </button>
      </div>

      <div class="alert alert-danger" *ngIf="erroMeusTickets">
        {{erroMeusTickets}}
      </div>

      <div class="estado-vazio" *ngIf="carregandoMeusTickets">
        Carregando seus tickets...
      </div>

      <div class="estado-vazio" *ngIf="!carregandoMeusTickets && meusTickets.length === 0">
        Nenhum ticket aberto sob sua responsabilidade.
      </div>

      <div class="meus-tickets-lista" *ngIf="!carregandoMeusTickets && meusTickets.length > 0">
        <div class="meu-ticket-item"
             role="button"
             tabindex="0"
             title="Abrir ticket no superadmin"
             *ngFor="let ticket of meusTickets"
             [ngClass]="[classePrioridadeTicket(ticket.prioridade), classeIdadeTicket(ticket)]"
             (click)="abraTicketSuperadmin(ticket, $event)"
             (keyup.enter)="abraTicketSuperadmin(ticket, $event)">
          <div>
            <strong>
              <small class="ticket-numero">#{{ticket.id}}</small>
              {{ticket.titulo}}
            </strong>
            <a *ngIf="ticket.empresaDominio"
               class="empresa-admin-link"
               [href]="obtenhaLinkAdminEmpresa(ticket)"
               target="_blank"
               rel="noopener"
               (click)="$event.stopPropagation()">
              {{ticket.empresaNome}}
            </a>
            <span *ngIf="!ticket.empresaDominio">{{ticket.empresaNome}}</span>
          </div>
          <div class="meu-ticket-meta">
            <span class="badge badge-light">{{textoStatusTicket(ticket.status)}}</span>
            <span class="badge badge-prioridade" [ngClass]="classePrioridadeTicket(ticket.prioridade)">
              {{textoPrioridadeTicket(ticket.prioridade)}}
            </span>
            <span>{{textoTipoTicket(ticket.tipo, ticket.tipoOutroDescricao)}}</span>
            <span>{{textoAreaTicket(ticket.areaSistema)}}</span>
            <span class="ticket-idade" [ngClass]="classeIdadeTicket(ticket)">
              {{textoIdadeTicket(ticket)}}
            </span>
            <button type="button"
                    class="btn btn-outline-primary btn-sm"
                    (click)="abraGrupoTicket(ticket); $event.stopPropagation()"
                    *ngIf="ticket.grupoWhatsappChatId">
              <i class="fab fa-whatsapp mr-1"></i>
              Abrir grupo
            </button>
            <span>Atualizado em {{ticket.dataAtualizacao | date:'dd/MM HH:mm'}}</span>
          </div>
        </div>
      </div>
    </section>

    <section class="meus-tickets-suporte tickets-destaque-suporte" *ngIf="!contexto.elegivel">
      <div class="meus-tickets-topo">
        <div>
          <p class="secao-label">Fila em destaque</p>
          <h5>Prioritários e antigos</h5>
          <span>{{ticketsDestaqueTotal}} ticket(s) aberto(s) fora da sua fila</span>
        </div>
      </div>

      <div class="alert alert-danger" *ngIf="erroTicketsDestaque">
        {{erroTicketsDestaque}}
      </div>

      <div class="estado-vazio" *ngIf="carregandoTicketsDestaque">
        Carregando tickets em destaque...
      </div>

      <div class="estado-vazio" *ngIf="!carregandoTicketsDestaque && ticketsDestaque.length === 0">
        Nenhum ticket aberto em destaque.
      </div>

      <div class="meus-tickets-lista" *ngIf="!carregandoTicketsDestaque && ticketsDestaque.length > 0">
        <div class="meu-ticket-item"
             role="button"
             tabindex="0"
             title="Abrir ticket no superadmin"
             *ngFor="let ticket of ticketsDestaque"
             [ngClass]="[classePrioridadeTicket(ticket.prioridade), classeIdadeTicket(ticket)]"
             (click)="abraTicketSuperadmin(ticket, $event)"
             (keyup.enter)="abraTicketSuperadmin(ticket, $event)">
          <div>
            <strong>
              <small class="ticket-numero">#{{ticket.id}}</small>
              {{ticket.titulo}}
            </strong>
            <a *ngIf="ticket.empresaDominio"
               class="empresa-admin-link"
               [href]="obtenhaLinkAdminEmpresa(ticket)"
               target="_blank"
               rel="noopener"
               (click)="$event.stopPropagation()">
              {{ticket.empresaNome}}
            </a>
            <span *ngIf="!ticket.empresaDominio">{{ticket.empresaNome}}</span>
          </div>
          <div class="meu-ticket-meta">
            <span class="badge badge-light">{{textoStatusTicket(ticket.status)}}</span>
            <span class="badge badge-prioridade" [ngClass]="classePrioridadeTicket(ticket.prioridade)">
              {{textoPrioridadeTicket(ticket.prioridade)}}
            </span>
            <span>{{textoTipoTicket(ticket.tipo, ticket.tipoOutroDescricao)}}</span>
            <span>{{textoAreaTicket(ticket.areaSistema)}}</span>
            <span class="ticket-idade" [ngClass]="classeIdadeTicket(ticket)">
              {{textoIdadeTicket(ticket)}}
            </span>
            <span *ngIf="ticket.responsavelNome">Com {{ticket.responsavelNome}}</span>
            <button type="button"
                    class="btn btn-primary btn-sm"
                    (click)="assumaTicketDestaque(ticket, $event)"
                    [disabled]="assumindoTicketId === ticket.id">
              <i class="fa" [ngClass]="assumindoTicketId === ticket.id ? 'fa-spinner fa-spin' : 'fa-hand-paper'"></i>
              Assumir
            </button>
            <button type="button"
                    class="btn btn-outline-primary btn-sm"
                    (click)="abraGrupoTicket(ticket); $event.stopPropagation()"
                    *ngIf="ticket.grupoWhatsappChatId">
              <i class="fab fa-whatsapp mr-1"></i>
              Abrir grupo
            </button>
            <span>Atualizado em {{ticket.dataAtualizacao | date:'dd/MM HH:mm'}}</span>
          </div>
        </div>
      </div>
    </section>

    <div class="atalhos-suporte-empresa" *ngIf="contexto.vinculado || !contexto.elegivel">
      <a class="atalho-suporte-link"
         href="https://ajuda.meucardapio.ai"
         target="_blank"
         rel="noopener"
         title="Abrir ajuda do MeuCardapio">
        <i class="fa fa-life-ring"></i>
        Ajuda
      </a>
      <a class="atalho-suporte-link"
         href="https://promokitconsulta.netlify.app/"
         target="_blank"
         rel="noopener"
         title="Abrir manual do suporte">
        <i class="fa fa-search"></i>
        Manual
      </a>
      <a class="atalho-suporte-link"
         href="/admin/manual-modo-suporte"
         target="_blank"
         rel="noopener"
         title="Abrir manual da funcionalidade modo suporte">
        <i class="fa fa-info-circle"></i>
        Modo suporte
      </a>
    </div>

    <div class="suporte-grid" *ngIf="contexto.elegivel">
      <section class="painel-principal">
        <div class="status-linha">
          <span class="badge badge-info">{{contexto.grupo?.prefixo}}</span>
          <span *ngIf="contexto.vinculado" class="badge badge-success">Vinculado</span>
          <span *ngIf="!contexto.vinculado" class="badge badge-warning">Sem vínculo</span>
        </div>

        <div *ngIf="contexto.vinculado" class="empresa-contexto">
          <div class="empresa-topo">
            <div>
              <p class="secao-label">Empresa em suporte</p>
              <h5>
                <a *ngIf="contexto.empresaSuporte?.dominio"
                   class="empresa-contexto-link"
                   [href]="obtenhaLinkAdminEmpresa(contexto.empresaSuporte)"
                   target="_blank"
                   rel="noopener"
                   title="Abrir área administrativa da empresa">
                  {{contexto.empresaSuporte?.nome}}
                </a>
                <span *ngIf="!contexto.empresaSuporte?.dominio">{{contexto.empresaSuporte?.nome}}</span>
              </h5>
            </div>

            <button type="button"
                    class="btn btn-outline-danger btn-sm"
                    (click)="abraDesvincular()"
                    *ngIf="!exibindoDesvincular">
              Desvincular
            </button>
          </div>

          <div class="empresa-dados">
            <span *ngIf="contexto.empresaSuporte?.dominio">
              <i class="fa fa-globe mr-1"></i>
              <a class="empresa-admin-link"
                 [href]="obtenhaLinkAdminEmpresa(contexto.empresaSuporte)"
                 target="_blank"
                 rel="noopener"
                 title="Abrir área administrativa da empresa">
                {{contexto.empresaSuporte?.dominio}}
              </a>
            </span>
            <span *ngIf="contexto.empresaSuporte?.cnpj">
              <i class="fa fa-id-card mr-1"></i>{{contexto.empresaSuporte?.cnpj}}
            </span>
            <span *ngIf="contexto.empresaSuporte?.whatsapp">
              <i class="fab fa-whatsapp mr-1"></i>{{contexto.empresaSuporte?.whatsapp}}
            </span>
          </div>

          <app-tickets-suporte
            [empresa]="contexto.empresaSuporte"
            [grupo]="contexto.grupo"
            [compacto]="true">
          </app-tickets-suporte>

          <section class="acoes-rapidas-suporte">
            <div class="acoes-rapidas-topo">
              <div>
                <p class="secao-label">Ações rápidas</p>
                <h6>Operações da empresa</h6>
              </div>

              <button type="button"
                      class="btn btn-outline-primary btn-sm"
                      (click)="carregueAcoesRapidas()"
                      [disabled]="carregandoAcoesRapidas">
                <i class="fa" [ngClass]="carregandoAcoesRapidas ? 'fa-spinner fa-spin' : 'fa-sync'"></i>
                Atualizar
              </button>
            </div>

            <div class="alert alert-danger" *ngIf="erroAcoesRapidas">
              {{erroAcoesRapidas}}
            </div>

            <div class="estado-vazio" *ngIf="carregandoAcoesRapidas && !acoesRapidas">
              Carregando ações rápidas...
            </div>

            <ng-container *ngIf="acoesRapidas">
              <div class="acoes-resumo-grid">
                <div class="acao-resumo-item" [ngClass]="classeBloqueioEmpresa()">
                  <span>Bloqueio</span>
                  <strong>{{textoBloqueioEmpresa()}}</strong>
                  <small *ngIf="acoesRapidas.empresa?.dataBloqueioAuto">
                    {{acoesRapidas.empresa?.dataBloqueioAuto | date:'dd/MM/yyyy'}}
                  </small>
                </div>

                <div class="acao-resumo-item">
                  <span>Próximo vencimento</span>
                  <strong *ngIf="acoesRapidas.financeiro?.dataProximoVencimento">
                    {{acoesRapidas.financeiro?.dataProximoVencimento | date:'dd/MM/yyyy'}}
                  </strong>
                  <strong *ngIf="!acoesRapidas.financeiro?.dataProximoVencimento">Não informado</strong>
                  <small>{{textoFormasPagamento(acoesRapidas.financeiro?.formasPagamento)}}</small>
                </div>

                <div class="acao-resumo-item">
                  <span>Último pagamento</span>
                  <strong *ngIf="acoesRapidas.financeiro?.ultimaFaturaPaga?.dataPagamento">
                    {{acoesRapidas.financeiro?.ultimaFaturaPaga?.dataPagamento | date:'dd/MM/yyyy'}}
                  </strong>
                  <strong *ngIf="!acoesRapidas.financeiro?.ultimaFaturaPaga?.dataPagamento">Sem registro</strong>
                  <small *ngIf="acoesRapidas.financeiro?.faturaAberta?.dataVencimento">
                    Aberta: {{acoesRapidas.financeiro?.faturaAberta?.dataVencimento | date:'dd/MM/yyyy'}}
                  </small>
                </div>
              </div>

              <div class="acoes-bloco" *ngIf="acoesRapidas.empresa?.bloqueada">
                <div class="acoes-bloco-topo">
                  <strong>Financeiro</strong>
                  <span [ngClass]="podeDesbloqueioEmergencial() ? 'texto-alerta' : 'texto-ok'">
                    {{podeDesbloqueioEmergencial() ? 'Emergencial disponível' : 'Já usado neste vencimento'}}
                  </span>
                </div>

                <div class="acoes-financeiro">
                  <button type="button"
                          class="btn btn-warning btn-sm"
                          *ngIf="podeDesbloqueioEmergencial()"
                          (click)="desbloqueieEmergencialmente()"
                          [disabled]="desbloqueandoEmergencial || executandoAcaoRapida()">
                    <i class="fa" [ngClass]="desbloqueandoEmergencial ? 'fa-spinner fa-spin' : 'fa-unlock'"></i>
                    Desbloqueio emergencial
                  </button>
                </div>
              </div>

              <div class="acoes-bloco">
                <div class="acoes-bloco-topo">
                  <strong>Campanhas</strong>
                  <span>{{acoesRapidas.campanhasPendentes?.length || 0}}</span>
                </div>

                <div class="estado-vazio" *ngIf="!acoesRapidas.campanhasPendentes?.length">
                  Nenhuma campanha pendente de aprovação.
                </div>

                <div class="campanhas-rapidas-lista" *ngIf="acoesRapidas.campanhasPendentes?.length">
                  <div class="campanha-rapida-item" *ngFor="let campanha of acoesRapidas.campanhasPendentes">
                    <div>
                      <strong>#{{campanha.id}} {{campanha.nome}}</strong>
                      <span *ngIf="campanha.horarioEnvio">
                        Envio: {{campanha.horarioEnvio | date:'dd/MM HH:mm'}}
                      </span>
                      <span *ngIf="campanha.tipoFiltro">Filtro: {{campanha.tipoFiltro}}</span>
                      <span *ngIf="campanha.quantidadeContatos !== null && campanha.quantidadeContatos !== undefined">
                        {{campanha.quantidadeContatos}} contato{{campanha.quantidadeContatos === 1 ? '' : 's'}}
                      </span>
                      <span class="texto-ok" *ngIf="campanhaAprovada(campanha)">Aprovada</span>
                      <span *ngIf="!campanha.foiTestada">Não testada</span>
                    </div>

                    <div class="campanha-rapida-acoes">
                      <a *ngIf="campanha.linkCampanha"
                         class="btn btn-outline-primary btn-sm"
                         [href]="campanha.linkCampanha"
                         target="_blank"
                         rel="noopener">
                        <i class="fa fa-external-link-alt"></i>
                        Abrir
                      </a>

                      <button type="button"
                              class="btn btn-success btn-sm"
                              *ngIf="!campanhaAprovada(campanha)"
                              (click)="aproveCampanha(campanha)"
                              [disabled]="aprovandoCampanhaId === campanha.id">
                        <i class="fa" [ngClass]="aprovandoCampanhaId === campanha.id ? 'fa-spinner fa-spin' : 'fa-check'"></i>
                        Aprovar
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div class="acoes-bloco">
                <div class="acoes-bloco-topo">
                  <strong>Loja</strong>
                  <span [ngClass]="acoesRapidas.loja?.fechada ? 'texto-alerta' : 'texto-ok'">
                    {{acoesRapidas.loja?.fechada ? 'Fechada' : 'Aberta'}}
                  </span>
                </div>

                <small class="loja-tempo" *ngIf="acoesRapidas.loja?.fechada">
                  {{textoTempoFechamento(acoesRapidas.loja)}}
                  <span *ngIf="acoesRapidas.loja?.mensagem"> - {{acoesRapidas.loja?.mensagem}}</span>
                </small>

                <textarea class="form-control form-control-sm"
                          rows="2"
                          [(ngModel)]="mensagemFechamentoLoja"
                          placeholder="Mensagem opcional para fechamento"></textarea>

                <div class="acoes-fechamento">
                  <button type="button"
                          class="btn btn-outline-success btn-sm"
                          *ngIf="acoesRapidas.loja?.fechada"
                          (click)="abraLoja()"
                          [disabled]="abrindoLoja || fechandoLojaTempo !== null">
                    <i class="fa" [ngClass]="abrindoLoja ? 'fa-spinner fa-spin' : 'fa-door-open'"></i>
                    Reabrir
                  </button>
                  <button type="button"
                          class="btn btn-danger btn-sm"
                          (click)="fecheLojaHoje()"
                          [disabled]="fechandoLojaTempo !== null || abrindoLoja">
                    <i class="fa fa-calendar"></i>
                    Fechar hoje
                  </button>
                  <button type="button"
                          class="btn btn-outline-danger btn-sm"
                          (click)="fecheLoja(30)"
                          [disabled]="fechandoLojaTempo !== null || abrindoLoja">
                    <i class="fa" [ngClass]="fechandoLojaTempo === 30 ? 'fa-spinner fa-spin' : 'fa-clock'"></i>
                    30 min
                  </button>
                  <button type="button"
                          class="btn btn-outline-danger btn-sm"
                          (click)="fecheLoja(60)"
                          [disabled]="fechandoLojaTempo !== null || abrindoLoja">
                    <i class="fa" [ngClass]="fechandoLojaTempo === 60 ? 'fa-spinner fa-spin' : 'fa-clock'"></i>
                    1h
                  </button>
                  <button type="button"
                          class="btn btn-outline-danger btn-sm"
                          (click)="fecheLoja(120)"
                          [disabled]="fechandoLojaTempo !== null || abrindoLoja">
                    <i class="fa" [ngClass]="fechandoLojaTempo === 120 ? 'fa-spinner fa-spin' : 'fa-clock'"></i>
                    2h
                  </button>
                </div>
              </div>
            </ng-container>
          </section>

          <div class="acao-rapida-backdrop" *ngIf="acaoRapidaPendente">
            <div class="acao-rapida-modal">
              <div class="acao-rapida-modal-topo">
                <div>
                  <p class="secao-label">Ação rápida</p>
                  <h6>{{acaoRapidaPendente.titulo}}</h6>
                </div>
                <button type="button"
                        class="btn btn-link btn-sm"
                        (click)="canceleAcaoRapida()"
                        [disabled]="executandoAcaoRapida()">
                  <i class="fa fa-times"></i>
                </button>
              </div>

              <div class="alert alert-danger" *ngIf="erroAcaoRapida">
                {{erroAcaoRapida}}
              </div>

              <div class="form-group">
                <label>Solicitação original do cliente</label>
                <small class="acao-rapida-ajuda">Copie aqui a mensagem em que o cliente solicita essa ação.</small>
                <textarea class="form-control"
                          rows="4"
                          [(ngModel)]="solicitacaoClienteAcaoRapida"
                          [disabled]="executandoAcaoRapida()"></textarea>
              </div>

              <div class="form-group">
                <label>{{labelMotivoAcaoRapida()}}</label>
                <textarea class="form-control"
                          rows="3"
                          [(ngModel)]="motivoAcaoRapida"
                          [disabled]="executandoAcaoRapida()"></textarea>
              </div>

              <div class="acao-rapida-modal-acoes">
                <button type="button"
                        class="btn btn-link btn-sm"
                        (click)="canceleAcaoRapida()"
                        [disabled]="executandoAcaoRapida()">
                  Cancelar
                </button>
                <button type="button"
                        class="btn btn-primary btn-sm"
                        (click)="confirmeAcaoRapida()"
                        [disabled]="executandoAcaoRapida()">
                  <i class="fa" [ngClass]="executandoAcaoRapida() ? 'fa-spinner fa-spin' : 'fa-check'"></i>
                  Confirmar
                </button>
              </div>
            </div>
          </div>

          <div class="desvincular-form" *ngIf="exibindoDesvincular">
            <label>Justificativa para desvincular</label>
            <textarea class="form-control"
                      rows="3"
                      [(ngModel)]="justificativaDesvinculo"
                      placeholder="Explique por que este grupo será desvinculado da empresa."></textarea>
            <div class="acoes-desvincular">
              <button type="button"
                      class="btn btn-link btn-sm"
                      (click)="canceleDesvincular()"
                      [disabled]="desvinculando">
                Cancelar
              </button>
              <button type="button"
                      class="btn btn-danger btn-sm"
                      (click)="desvinculeGrupo()"
                      [disabled]="desvinculando || !justificativaDesvinculo">
                <i class="fa" [ngClass]="desvinculando ? 'fa-spinner fa-spin' : 'fa-unlink'"></i>
                Confirmar desvínculo
              </button>
            </div>
          </div>

        </div>

        <div *ngIf="!contexto.vinculado" class="vinculo-form">
          <p class="secao-label">Vincular grupo</p>

          <div class="input-group mb-2">
            <input class="form-control"
                   placeholder="Buscar empresa por nome, domínio ou CNPJ"
                   [(ngModel)]="termoBusca"
                   (ngModelChange)="agendeBuscaEmpresas()"
                   (keyup.enter)="busqueEmpresas()">
            <div class="input-group-append">
              <button type="button"
                      class="btn btn-outline-primary"
                      (click)="busqueEmpresas()"
                      [disabled]="buscandoEmpresas">
                <i class="fa" [ngClass]="buscandoEmpresas ? 'fa-spinner fa-spin' : 'fa-search'"></i>
              </button>
            </div>
          </div>

          <div class="lista-empresas" *ngIf="empresas.length > 0">
            <button type="button"
                    class="empresa-opcao"
                    *ngFor="let empresaItem of empresas"
                    [class.selecionada]="empresaSelecionada?.id === empresaItem.id"
                    (click)="selecioneEmpresa(empresaItem)">
              <strong>{{empresaItem.nome}}</strong>
              <span>{{empresaItem.dominio || empresaItem.cnpj || 'Empresa sem domínio'}}</span>
            </button>
          </div>

          <div class="estado-vazio" *ngIf="!buscandoEmpresas && !buscouEmpresas">
            Digite o nome da empresa para buscar.
          </div>

          <div class="estado-vazio" *ngIf="!buscandoEmpresas && buscouEmpresas && empresas.length === 0">
            Nenhuma empresa encontrada.
          </div>

          <div class="estado-vazio" *ngIf="buscandoEmpresas">
            Buscando empresas...
          </div>

          <button type="button"
                  class="btn btn-primary btn-block mt-3"
                  (click)="vinculeGrupo()"
                  [disabled]="vinculando || !empresaSelecionada">
            <i class="fa fa-link mr-1"></i>
            Vincular empresa
          </button>
        </div>
      </section>

      <section class="historico-vinculos" *ngIf="contexto.historico?.length">
        <p class="secao-label">Histórico de vínculos</p>
        <div class="historico-item" *ngFor="let item of contexto.historico">
          <div class="historico-topo">
            <strong>{{textoAcaoHistorico(item.acao)}}</strong>
            <span>{{item.dataCriacao | date:'dd/MM/yyyy HH:mm'}}</span>
          </div>
          <div class="historico-meta">
            {{item.usuarioNome}} - {{item.empresaSuporteNome}}
          </div>
          <p *ngIf="item.justificativa">{{item.justificativa}}</p>
        </div>
      </section>

    </div>
  </ng-container>
</div>
